import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=a95ab93c&scoped=true"
import script from "./Values.vue?vue&type=script&lang=ts"
export * from "./Values.vue?vue&type=script&lang=ts"
import style0 from "./Values.vue?vue&type=style&index=0&id=a95ab93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ab93c",
  null
  
)

export default component.exports